import { useState } from 'react';
import type { JobChangeProcess } from '../../types/JobChangeProcess';
import JobChangeProcessListItem from './JobChangeProcessListItem';
import JobChangeProcessStatusUpdateModal from '../modal/JobChangeProcessStatusUpdateModal';
import ListItemLoading from './ListItemLoading';
import ListItemNoData from './ListItemNoData';
import Loading from '@/components/Loading';
import type { ActiveUser } from '../../../types/ActiveUser';

type Props = {
  jobChangeProcesses: JobChangeProcess[];
  isLoading: boolean;
  isFetchingNextPage?: boolean;
  isSidebarOpen: boolean;
  openSidebar: (isValue: boolean) => void;
  jobchangeProcessesRefetch: () => Promise<void>;
  activeUsers: ActiveUser[];
  currentUserId?: number;
  onUpdateCandidateAssignees: (candidateProfileId: number, userIds: number[]) => void;
};

export default function JobChangeProcessList({
  jobChangeProcesses,
  isLoading,
  isFetchingNextPage = false,
  isSidebarOpen,
  openSidebar,
  jobchangeProcessesRefetch,
  activeUsers,
  currentUserId,
  onUpdateCandidateAssignees,
}: Props) {
  const [statusModalOpen, setStatusModalOpen] = useState(false);

  return (
    <div className="relative flex flex-col">
      <div className="sticky top-4 z-20 flex h-[36px] items-center justify-around rounded-s bg-[#E7E7E7] px-6">
        <p className="w-[234px] min-w-[234px] text-center text-sm font-bold">求職者</p>
        <p className="w-[200px] max-w-[200px] text-center text-sm font-bold">企業名 / 求人</p>
        <p className="w-[180px] max-w-[180px] text-center text-sm font-bold">ステータス</p>
        <p className="w-[176px] max-w-[176px] text-center text-sm font-bold">選考日程</p>
        <p className="w-[188px] max-w-[188px] text-center text-sm font-bold">メモ</p>
      </div>
      <div className="hidden-scrollbar flex flex-col gap-4 px-1 pt-4">
        {isLoading ? (
          <>
            {Array.from({ length: 10 }).map((_, key) => {
              return <ListItemLoading key={key} />;
            })}
          </>
        ) : (
          <>
            {jobChangeProcesses.length === 0 ? (
              <div className="mt-[100px]">
                <ListItemNoData />
              </div>
            ) : (
              jobChangeProcesses.map((j, key) => {
                return (
                  <JobChangeProcessListItem
                    key={key}
                    jobChangeProcess={j}
                    openSidebar={openSidebar}
                    statusModalOpen={() => setStatusModalOpen(true)}
                    jobchangeProcessesRefetch={jobchangeProcessesRefetch}
                    isSidebarOpen={isSidebarOpen}
                    activeUsers={activeUsers}
                    currentUserId={currentUserId}
                    onUpdateCandidateAssignees={onUpdateCandidateAssignees}
                  />
                );
              })
            )}
          </>
        )}
      </div>
      {isFetchingNextPage && (
        <div className="flex justify-center py-md">
          <Loading size="small" />
        </div>
      )}
      <JobChangeProcessStatusUpdateModal
        open={statusModalOpen}
        onOpenChange={setStatusModalOpen}
        jobchangeProcessesRefetch={jobchangeProcessesRefetch}
      />
    </div>
  );
}
